import gql from 'graphql-tag'
import client from '@stores/apollo'
import { IIntegrations } from './types'
import { IntegrationFragment } from './fragments'

interface IPayload {
  data: {
    viewer: {
      company: {
        integrations: IIntegrations
      }
    }
  }
}

export default function list(): Promise<IIntegrations> {
  return client.gql.query({ query }).then(
    ({
      data: {
        viewer: {
          company: { integrations },
        },
      },
    }: IPayload) => integrations
  )
}

const query = gql`
  query Integrations {
    viewer {
      company {
        integrations {
          available {
            ...IntegrationFragment
          }
          active {
            ...IntegrationFragment
          }
        }
      }
    }
  }
  ${IntegrationFragment}
`
